import { render, staticRenderFns } from "./AnchorageMenu.vue?vue&type=template&id=ec083862&scoped=true&"
import script from "./AnchorageMenu.vue?vue&type=script&lang=js&"
export * from "./AnchorageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec083862",
  null
  
)

export default component.exports